import { render, staticRenderFns } from "./PayLink.vue?vue&type=template&id=4efe9062&"
import script from "./PayLink.vue?vue&type=script&lang=js&"
export * from "./PayLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports